/*
 *
 * Modal constants
 *
 */
export const SHOW_OVERLAY = 'app/ToastManager/SHOW_OVERLAY';
export const HIDE_OVERLAY = 'app/ToastManager/HIDE_OVERLAY';
export const PUSH_TOAST = 'app/ToastManager/PUSH_TOAST';
export const SET_TOASTS = 'app/ToastManager/SET_TOASTS';
export const REMOVE_TOAST = 'app/ToastManager/REMOVE_TOAST';
export const UPDATE_TOAST = 'app/ToastManager/UPDATE_TOAST';
export const INCREMENT_DOWNLOAD_ERROR_REPORTS_COUNT = 'app/ToastManager/INCREMENT_DOWNLOAD_ERROR_REPORTS_COUNT';
export const DECREMENT_DOWNLOAD_ERROR_REPORTS_COUNT = 'app/ToastManager/DECREMENT_DOWNLOAD_ERROR_REPORTS_COUNT';
